import {
  FormPagePropertyItemSelectionRegistrationLimit,
  FormPagePropertyItemSingleSelectionCandidate,
} from 'backend';
import {
  FormPageInputItemSingleSelection,
  FormPageInputItemSingleSelectionPulldown,
  SingleSelectionItem,
  SingleSelectionProperty,
} from 'shared';
import { FormFieldInputProps, FormFieldInputItemProps } from '../shared';

export type SingleSelectionEvents = {
  onSelectChange: (value: number | undefined) => void;
  onSubtextChange: (value: number | null, subtext: string) => void;
  onSubtextBlur: (value: number | null, subtext: string) => void;
};

export type SingleSelectionInputProps<
  P extends SingleSelectionProperty = SingleSelectionProperty,
  I extends FormPageInputItemSingleSelection = FormPageInputItemSingleSelection,
> = Omit<FormFieldInputProps<P, I>, 'onChange' | 'onBlur'> &
  SingleSelectionEvents & {
    parentValue: FormPageInputItemSingleSelectionPulldown['value'];
  };

export type SingleSelectionInputItemProps<
  P extends SingleSelectionProperty = SingleSelectionProperty,
  I extends FormPageInputItemSingleSelection = FormPageInputItemSingleSelection,
> = Omit<FormFieldInputItemProps<P, I>, 'onChange' | 'onBlur'>;

type MapperRegistrationLimit = (
  candidate: FormPagePropertyItemSingleSelectionCandidate,
) => SingleSelectionItem;
export const mapperRegistrationLimit = (
  limits: FormPagePropertyItemSelectionRegistrationLimit[] | undefined,
): MapperRegistrationLimit => {
  return (
    candidate: FormPagePropertyItemSingleSelectionCandidate,
  ): SingleSelectionItem => {
    const limit = limits?.find((l) => l.value === candidate.value);
    return {
      ...candidate,
      remain:
        limit?.upperLimit == null || limit?.registrationCount == null
          ? undefined
          : limit.upperLimit - limit.registrationCount,
      isAnswered: limit?.isAnswered,
      registrationDeadline: limit?.registrationDeadline,
    };
  };
};
